import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { RedirectionService } from '../redirection.service';
import { AddRedirection } from '../redirection.interface';

@Component({
    selector: 'app-add-redirection',
    templateUrl: './add-redirection.component.html',
    styleUrls: ['./add-redirection.component.scss'],
})
export class AddRedirectionComponent {
    // general error
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;
    helper = helper;

    isLoading = false;

    filterParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    form: FormGroup = new FormGroup({
        name: new FormControl('', [Validators.required]),
        email: new FormControl('', [Validators.required, Validators.email]),
    });

    constructor(
        private dialogRef: MatDialogRef<AddRedirectionComponent>,
        private requestService: RedirectionService,
        private notificationService: NotificationService,
    ) { }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    ngOnInit() { }

    submitForm() {
        this.isLoading = true;

        const { name, email } = this.form.value;
        const payload: AddRedirection = {
            name, email
        };

        this.requestService
            .storeEntry(payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res: any) => {
                    // Trimite obiectul creat înapoi la componenta care a deschis dialogul
                    this.dialogRef.close({
                        success: true,
                        data: res.data // sau res.data dacă response-ul vine wrapper
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                },
            });
    }
}
